import React from 'react';
import * as Icon from 'react-feather';

import ximage from '../../assets/twitter.png';
import linkedinimage from '../../assets/linkedin.png';
import youtubeimage from '../../assets/youtube.png';
import tiktok from '../../assets/tiktok.png';
import facebook from '../../assets/facebook.png';
import instagramimage from '../../assets/instagram.png';
import threadsimage from '../../assets/threads.png';
import blueskyimage from '../../assets/bluesky.png';
import discordimage from '../../assets/discord.png';
import pinterestimage from '../../assets/pinterest.png';
import redditimage from '../../assets/reddit.png';

const platformIcons = {
  twitter: ximage, linkedin: linkedinimage, linkedin_page: linkedinimage,
  youtube: youtubeimage, tiktok, facebook, instagram: instagramimage,
  threads: threadsimage, bluesky: blueskyimage, pinterest: pinterestimage,
  discord: discordimage,
  reddit: redditimage,
};

// Circle with account initial — shown when profile picture fails to load
function InitialAvatar({ name = '', size = 18 }) {
  const str = typeof name === 'string' ? name : String(name ?? '');
  const letter = (str || '?')[0].toUpperCase();
  const colors = ['#e0f2fe','#dcfce7','#fef9c3','#fce7f3','#ede9fe','#ffedd5'];
  const textColors = ['#0369a1','#15803d','#a16207','#9d174d','#6d28d9','#c2410c'];
  const idx = Math.abs(letter.charCodeAt(0) - 65) % colors.length;
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: colors[idx], display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.45, fontWeight: 600, color: textColors[idx],
      flexShrink: 0,
    }}>
      {letter}
    </div>
  );
}

// Platform icon with fallback to Globe icon
function PlatformIcon({ type, size = 24 }) {
  const src = platformIcons[type];
  if (!src) {
    return (
      <div style={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon.Globe size={size * 0.75} color="#7d8fa3" />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={type}
      style={{ width: size, height: size, objectFit: 'contain' }}
      onError={e => {
        e.target.onerror = null;
        e.target.style.display = 'none';
      }}
    />
  );
}

// Profile picture with initial-avatar fallback
function ProfilePicture({ src, name, size = 18, style: extraStyle = {} }) {
  const [failed, setFailed] = React.useState(false);
  if (failed || !src) return <InitialAvatar name={name} size={size} />;
  return (
    <img
      src={src}
      alt=""
      style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', ...extraStyle }}
      onError={() => setFailed(true)}
    />
  );
}

// Stacked platform+avatar icons used in post cards
function AccountIcons({ accounts = [] }) {
  return (
    <div className="d-flex gap-1 flex-wrap">
      {accounts.map((account, i) => (
        <div key={i} className="position-relative d-inline-flex align-items-center" style={{ width: 38 }}>
          <PlatformIcon type={account.type} size={24} />
          <div style={{
            position: 'absolute', left: 12, top: 10,
            border: '2px solid #fff', borderRadius: '50%', background: '#fff',
          }}>
            <ProfilePicture
              src={account.picture || account.image}
              name={account.name}
              size={18}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export { AccountIcons, PlatformIcon, ProfilePicture, InitialAvatar };
